import {
  GET_ARTISTS,
  GET_ARTISTS_SUCCESS,
  GET_ARTISTS_FAIL,
  CLEAR_ARTISTS,
} from './actionTypes';

export const getArtists = (data, history) => ({
  type: GET_ARTISTS,
  payload: { data, history },
});

export const getArtistsSuccess = (data) => ({
  type: GET_ARTISTS_SUCCESS,
  payload: { data },
});

export const getArtistsFail = (error) => ({
  type: GET_ARTISTS_FAIL,
  payload: error,
});

export const clearArtistsData = () => ({
  type: CLEAR_ARTISTS,
  payload: '',
});
